import { CoreLadderTeamRow } from '../../../../views';
import './index.styl';
import { User } from '../../../../models';

import overall_ladder from './templates/overall_ladder.jst';
import round_by_round from './templates/round_by_round.jst';
import streak_ladder from './templates/streak_ladder.jst';
import view_tips from './templates/view_tips.jst';

/**
 * @desc League CoreLadderTeamRow Class
 * This class using on comp ladder page ('comps/:comp_id/ladder')
 */
export class LadderTeamRow extends CoreLadderTeamRow {
	getTemplate() {
		let template_type = this.getOption( 'template_type' ),
			template = '';

		if( status !== 'scheduled' ) {
			switch ( template_type ) {
				case 'overall':
					template = overall_ladder;
					break;
				case 'round_by_round':
					template = round_by_round;
					break;
				case 'streak':
					template = streak_ladder;
					break;
				case 'view-tips':
					template = view_tips;
					break;
				default:
					template = overall_ladder;
			}
			return template;
		}
		else {
			return false;
		}
	}

	updateModel() {
		const {
			template_type,
			tipping
		} = this.options;

		// BE returns the team's id under different names. This is historically...
		if( template_type !== 'view-tips' && template_type !== 'streak' ) {
			this.model.set( 'user_id', this.model.get('id') );
		}
		else {
			this.model.set( 'id', this.model.get('user_id') );
		}

		this.model
			.set({
				current_user_id: User.get( 'id' ),
				current_round: this.league.get( 'current_round' ),
				status: this.league.get( 'status' ),
				fixtures: this.league.get( 'fixtures' ),
				matches: tipping.toJSON()
			})
			.setAvatar();

		this.render();
	}
}

export default LadderTeamRow;